import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { type FieldValues, type Path, type RegisterOptions, useFormContext, useFormState } from 'react-hook-form';
import type { CheckboxProps } from '../../checkbox';
import Checkbox from '../../checkbox';
import type { LabelTooltipProps } from '../../label';
import FormWrapper from '../internals/form-wrapper';
export type FormCheckboxProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
  addon?: React.ReactNode;
  tooltip?: LabelTooltipProps;
  hideError?: boolean;
} & Omit<CheckboxProps, 'checked' | 'defaultChecked' | 'name' | 'onBlur' | 'ref' | 'label' | 'hasError'>;
export default function FormCheckbox(t0) {
  const $ = _c(48);
  let addon;
  let baseId;
  let checkboxProps;
  let label;
  let name;
  let onChange;
  let rules;
  let t1;
  let t2;
  let t3;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      id: baseId,
      errorPosition: t1,
      orientation: t2,
      addon,
      onChange,
      tooltip,
      hideError: t3,
      ...checkboxProps
    } = t0);
    $[0] = t0;
    $[1] = addon;
    $[2] = baseId;
    $[3] = checkboxProps;
    $[4] = label;
    $[5] = name;
    $[6] = onChange;
    $[7] = rules;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = tooltip;
  } else {
    addon = $[1];
    baseId = $[2];
    checkboxProps = $[3];
    label = $[4];
    name = $[5];
    onChange = $[6];
    rules = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    tooltip = $[11];
  }
  const errorPosition = t1 === undefined ? "relative" : t1;
  const orientation = t2 === undefined ? "vertical" : t2;
  const hideError = t3 === undefined ? false : t3;
  const {
    register,
    control,
    getFieldState
  } = useFormContext();
  let t4;
  if ($[12] !== checkboxProps.disabled || $[13] !== control || $[14] !== name) {
    t4 = {
      control,
      name,
      disabled: checkboxProps.disabled
    };
    $[12] = checkboxProps.disabled;
    $[13] = control;
    $[14] = name;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const formState = useFormState(t4);
  let t5;
  if ($[16] !== formState || $[17] !== getFieldState || $[18] !== name) {
    t5 = getFieldState(name, formState);
    $[16] = formState;
    $[17] = getFieldState;
    $[18] = name;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const {
    error
  } = t5;
  const contextId = useId();
  const id = baseId || contextId;
  let t6;
  if ($[20] !== name || $[21] !== register || $[22] !== rules) {
    t6 = register(name, {
      ...rules
    });
    $[20] = name;
    $[21] = register;
    $[22] = rules;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let reactHookFormOnChange;
  let rest;
  if ($[24] !== t6) {
    ({
      onChange: reactHookFormOnChange,
      ...rest
    } = t6);
    $[24] = t6;
    $[25] = reactHookFormOnChange;
    $[26] = rest;
  } else {
    reactHookFormOnChange = $[25];
    rest = $[26];
  }
  const t7 = error?.message;
  const t8 = formState.disabled || checkboxProps.disabled;
  let t9;
  if ($[27] !== onChange || $[28] !== reactHookFormOnChange) {
    t9 = e => {
      reactHookFormOnChange(e);
      onChange?.(e);
    };
    $[27] = onChange;
    $[28] = reactHookFormOnChange;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  const t10 = formState.disabled || checkboxProps.disabled;
  const t11 = !!error;
  let t12;
  if ($[30] !== checkboxProps || $[31] !== id || $[32] !== label || $[33] !== rest || $[34] !== t10 || $[35] !== t11 || $[36] !== t9) {
    t12 = <Checkbox {...checkboxProps} {...rest} onChange={t9} disabled={t10} hasError={t11} id={id} data-dd-privacy="mask" label={label} />;
    $[30] = checkboxProps;
    $[31] = id;
    $[32] = label;
    $[33] = rest;
    $[34] = t10;
    $[35] = t11;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== addon || $[39] !== errorPosition || $[40] !== hideError || $[41] !== id || $[42] !== orientation || $[43] !== t12 || $[44] !== t7 || $[45] !== t8 || $[46] !== tooltip) {
    t13 = <FormWrapper id={id} error={t7} errorPosition={errorPosition} addon={addon} size="default" orientation={orientation} fullWidth={true} disabled={t8} tooltip={tooltip} hideError={hideError}>{t12}</FormWrapper>;
    $[38] = addon;
    $[39] = errorPosition;
    $[40] = hideError;
    $[41] = id;
    $[42] = orientation;
    $[43] = t12;
    $[44] = t7;
    $[45] = t8;
    $[46] = tooltip;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  return t13;
}